
/** 
 * Utilities to switch on control , muted and autoplay 
* @param {HTMLVideoElement} video  
* @return {void}
*/
export const enableControlls = (video:HTMLVideoElement) => {
    video.controls = true;
    video.muted = false;
    video.autoplay=false;
    video.load();
}
/** 
 * Utilities to switch on control , muted and autoplay
* @param {HTMLVideoElement} video  
* @return {void}
*/
export const disableControlls = (video:HTMLVideoElement) => {
    video.setAttribute("muted",'');
    video.setAttribute("playsinline",'');
    video.setAttribute("autoplay",'');
    video.setAttribute("controls",'');
     setTimeout(() => {
     video.removeAttribute("controls");
       });
    video.controls = false;
    video.muted = true;
    video.autoplay=true;
    video.playsInline = true;
    video.load();
}